export const getImagePlaceholderByType = (type) => {
  if (type === "speakers") return "/media/avatars/dummy-avatar.jpg";
  if (type === "videos") return "/media/avatars/video_dummy.png";
  if (type === "topics") return "/media/avatars/dummy-img.jpg";
};
